module.exports.RADIUS = 6378137;
module.exports.FLATTENING = 1/298.257223563;
module.exports.POLAR_RADIUS = 6356752.3142;



//////////////////
// WEBPACK FOOTER
// ./node_modules/wgs84/index.js
// module id = 594
// module chunks = 0